import { render, staticRenderFns } from "./PedingProcess.vue?vue&type=template&id=865cfda2"
import script from "./PedingProcess.vue?vue&type=script&lang=js"
export * from "./PedingProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports